const SHOW_DIALOG_PANEL = 'client/dialogPanel/SHOW_DIALOG_PANEL';
const HIDE_DIALOG_PANEL = 'client/dialogPanel/HIDE_DIALOG_PANEL';

const initialState = {
  activeIds: [],
  data: {},
};

function dialogReducer(state = initialState, action = {}) {
  switch (action.type) {
    case SHOW_DIALOG_PANEL:
      return {
        ...state,
        activeIds: state.activeIds.concat(action.payload.panelId),
        data: {
          ...state.data,
          [action.payload.panelId]: action.payload.data,
        },
      };
    case HIDE_DIALOG_PANEL:
      const newData = { ...state.data };
      delete newData[state.activeIds[state.activeIds.length - 1]];
      return {
        ...state,
        activeIds: state.activeIds.slice(0, -1),
        data: newData,
      };
    default:
      return state;
  }
}

function showDialogPanel(panelId, data) {
  return {
    type: SHOW_DIALOG_PANEL,
    payload: {
      panelId,
      data,
    },
  };
}

function hideDialogPanel() {
  return {
    type: HIDE_DIALOG_PANEL,
  };
}

const actions = {
  showDialogPanel,
  hideDialogPanel,
};

export { actions };
export default dialogReducer;



// WEBPACK FOOTER //
// ./src/portfolio-shared/state/reducers/dialogPanelReducer.js